/**
 * Which export layout / API routing the download modal uses.
 *
 * - `default` — standard client detail export modal.
 * - `groupView` — Related Travelers grouped view (single PDF aligned with grouped tables, SFC-917).
 * - `dashboardGrouped` — Clients Dashboard multi-select export (SFC-1007); same layout/endpoint as groupView.
 */
export type DownloadSettingsModalVariant = 'default' | 'groupView' | 'dashboardGrouped';

export const DOWNLOAD_SETTINGS_MODAL_VARIANT_GROUP_VIEW: DownloadSettingsModalVariant = 'groupView';

export const DOWNLOAD_SETTINGS_MODAL_VARIANT_DASHBOARD_GROUPED: DownloadSettingsModalVariant = 'dashboardGrouped';

export function isGroupedExportVariant(variant: DownloadSettingsModalVariant): boolean {
  return variant === 'groupView' || variant === 'dashboardGrouped';
}
